import { Store } from 'vuex';
import i18n from '@/i18n';
import { RootState } from '@/store';
import router from '../router';
import { RouteNames } from '@/utils/router/router.models';

export class LocalStorageStateManager {
  private store: Store<RootState>;

  constructor(store: Store<RootState>) {
    this.store = store;

    if (!this.isEnabled) return;

    if (this.configurationExists) {
      this.askToRestore();
    } else {
      this.initListener();
    }
  }

  private initListener() {
    this.store.subscribe((_, state) => this.save(state));
  }

  private save(state: RootState) {
    localStorage.setItem('store', JSON.stringify(state));
  }

  private restore(stateToRestore: RootState) {
    this.store.dispatch('restoreState', stateToRestore);
  }

  private async askToRestore() {
    try {
      await this.store.dispatch('notify/openInfoModal', {
        headline: i18n.t('global.dialogs.restoreConfiguration.headline'),
        message: i18n.t('global.dialogs.restoreConfiguration.message'),
        declineCta: i18n.t('global.dialogs.restoreConfiguration.declineCta'),
        acceptCta: i18n.t('global.dialogs.restoreConfiguration.acceptCta')
      });

      this.restore(JSON.parse(localStorage.getItem('store') as string));

      router.push({
        name: this.store.state.app.currentRoute?.name || RouteNames.Summary,
        params: this.store.state.app.currentRoute?.params
      });

      this.initListener();
    } catch (error) {
      this.save(this.store.state);
      this.initListener();

      // Just save new state in localStorage, init listeners and go next
      // Vue navigation guards should now redirect to the start page
    }
  }

  private get configurationExists(): boolean {
    const stateToRestoreJSON: string | null = localStorage.getItem('store');

    return !!(stateToRestoreJSON && (JSON.parse(stateToRestoreJSON) as RootState).configuration.houseConfiguration);
  }

  private get isEnabled(): boolean {
    try {
      localStorage.setItem('test', 'test');
      localStorage.removeItem('test');

      return true;
    } catch (error) {
      return false;
    }
  }
}
